/* es5-ext/object/set-prototype-of/index */ function _(require, module, exports) {
    module.exports = require(355) /* ./is-implemented */()
        ? Object.setPrototypeOf
        : require(356) /* ./shim */;
}
